/**
 * Автоматический импорт всех router.js из '@/modules' с добавлением префикса
 * в виде названия папки модуля, конвертированного в kebab-case
 */

const initModules = (router) => {
  const routesModules = require.context('@/modules', true, /routes\.js$/);

  routesModules.keys().forEach((key) => {
    const importedRoutes = routesModules(key).default;
    router.addRoutes(importedRoutes.map((item) => ({
      ...item,
      path: `${item.path}`,
    })));
  });
};

export default initModules;
